import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = anonymous, object = signed in
  const [user, setUser] = useState(null);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("bps_access_token", data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    if (data.access_token) localStorage.setItem("bps_access_token", data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const claimAccess = useCallback(async (payload) => {
    const { data } = await api.post("/auth/claim-access", payload);
    if (data.access_token) localStorage.setItem("bps_access_token", data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) {
      // server-side logout is best-effort — always proceed to clear local auth
      console.warn("Server logout failed; clearing client-side session anyway", e?.message);
    }
    localStorage.removeItem("bps_access_token");
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, claimAccess, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
